export function isPlpSearchDataResults(response) {
    return 'response' in (response || {});
}
export function isPlpSearchDataRedirect(response) {
    return 'redirect' in (response || {});
}
export function isPlpBrowseDataResults(response) {
    return 'response' in (response || {});
}
export function isRangeFacet(facet) {
    return facet.type === 'range';
}
export function isMultipleOrBucketedFacet(facet) {
    return facet.type === 'multiple';
}
export function isSingleFacet(facet) {
    return facet.type === 'single';
}
export function isHierarchicalFacet(facet) {
    return facet.type === 'hierarchical';
}
export function isOptionFacet(facet) {
    return isMultipleOrBucketedFacet(facet) || isSingleFacet(facet) || isHierarchicalFacet(facet);
}
